export default {"src":"/_next/static/media/proctor-gamble.f47756b3.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};